<div class="card" role="region" aria-label="Giriş formu" *ngIf="isMobile">
  <div class="card-header d-flex justify-content-around align-items-center">
    <img src="https://ankara.edu.tr/assets/images/logo.png" class="logo" alt="Ankara Üniversitesi" />

    <div class="header-text ms-2">
      <div class="title">Ankara Üniversitesi</div>
      <div class="subtitle">Online Yoklama Platformu</div>
    </div>
  </div>

</div>
<nav class="navbar navbar-expand-lg navbar-transparent navbar-absolute fixed-top">

  <div class="container-fluid">

    <button mat-raised-button class="navbar-toggler" type="button" (click)="sidebarToggle()">
      <span class="sr-only">Toggle navigation</span>
      <span class="navbar-toggler-icon icon-bar"></span>
      <span class="navbar-toggler-icon icon-bar"></span>
      <span class="navbar-toggler-icon icon-bar"></span>
    </button>


  </div>
</nav>
